// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_1GwsFPGK4buk8_gE9aMt9w"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/styles.css
// module id = 1047
// module chunks = 0